module.exports = __webpack_public_path__ + "static/Logo@2x-b177febcd9671132c415a2b098d4ba3a.png";